module.exports = __webpack_public_path__ + "img/import-files-hover.a08396ed.svg";